export const GET_ALL_BEDS_PATIENTS_ENDPOINT =
  'api/ipd/bed-patient-assignments/getAllBedAndPatientsByStatusAndLocation'
export const GET_ASSIGNED_PATIENTS_FOR_A_BED_ENDPOINT =
  'api/ipd/bed-patient-assignments/getAssignedPatientForABed?bedStatus='
export const ALL_NOTIFICATIONS_STATUS =
  'api/ipd/notificationstatus/getAllNotifications'
export const ODOOCOGNITIVECARE_URL = '/api/v1/download_invoice_template'
export const ODOOCOGNITIVECARE_INVOICE_URL = '/odoo/invoicing'
export const SEND_WHATSAPP_MESSAGE = '/ipd/notification/sendNotification'
export const DMS_UPLOAD_AND_SEND_NOTIFICATION =
  '/ipd/notification/upload-file/async'
export const radiologySearchEndpoint = 'api/ipd/radiology/radiologyOrdersSearch'

export const GET_OPD_DIAGNOSIS_ENDPOINT =
  'api/thopopdservice/v1/opd/getDiagnosis?encounterId='
export const POST_OPD_DIAGNOSIS_ENDPOINT =
  'api/thopopdservice/v1/opd/saveDiagnosis'
export const GET_OPD_SYSTEMIC_ENDPOINT =
  'api/thopopdservice/v1/opd/getSystemicExamination?encounterId='
export const POST_OPD_SYSTEMIC_ENDPOINT =
  'api/thopopdservice/v1/opd/saveSystemicExamination'
export const GET_OPD_HISTORY_ENDPOINT =
  'api/thopopdservice/v1/opd/getHistoryAndExamination?encounterId='
export const POST_OPD_HISTORY_ENDPOINT =
  'api/thopopdservice/v1/opd/saveHistoryAndExamination'
export const GET_OPD_VITALS_ENDPOINT =
  'api/thopopdservice/v1/opd/getVitals?encounterId='
export const POST_OPD_VITALS_ENDPOINT = 'api/thopopdservice/v1/opd/saveVitals'
export const GET_OPD_TREATMENTPLAN_ENDPOINT =
  'api/thopopdservice/v1/opd/getTreatmentPlan?encounterId='
export const POST_OPD_TREATMENTPLAN_ENDPOINT =
  'api/thopopdservice/v1/opd/saveTreatmentPlan'
export const GET_OPD_PAINHISTORY_ENDPOINT =
  'api/thopopdservice/v1/opd/getPainHistory?encounterId='
export const POST_OPD_PAINHISTORY_ENDPOINT =
  'api/thopopdservice/v1/opd/savePainHistory'
export const GET_OPD_OBJECTIVE_ENDPOINT =
  'api/thopopdservice/v1/opd/getObjective?encounterId='
export const POST_OPD_OBJECTIVE_ENDPOINT =
  'api/thopopdservice/v1/opd/saveObjective'

export const GET_DOCTORS_ENDPOINT = 'api/doctor-app/v1/doctors'

export const DEVICE_VITALS_POST = 'api/ipd/vital-info/vitals'
export const DEVICE_VITALS_GET = 'api/ipd/vital-info/vitals?encounterId='
export const GET_DEVICE_RING_VITALS = 'api/ipd/jc-ring/v2/latest/'
export const GET_DEVICE_RING = 'api/ipd/jc-ring/'
export const GET_SLEEP_DATA = 'api/ipd/jc-ring/v2/sleepIntervals'

export const GET_ALL_ROLES = '/ayuvubharosa/portal/users/getAllRoles'
export const GET_PREMIUM_PRODUCTS = '/api/products/list'
export const GET_PREMIUM_AGE_BAND = '/api/pricelist/age_band'
export const GET_PREMIUM_PRICE_LIST = '/api/product/pricelist'

export const GET_MEMBERSHIP_BENIFITS = '/membership/benefits?line_id='
export const GET_MEMBERSHIP_PLAN_AND_PATIENT_DETAILS =
  '/membership/line?line_id='

export const UPLOAD_CANCER_SCREENING = 'api/cancer-screening/upload'
export const SUMIT_CANCER_SCREENING = 'api/cancer-screening/submit'
export const SUMIT_CANCER_SCREENING_DV = 'api/cancer-screening/submit-final'
export const GET_CANCER_SCREENING_OBSERVATION =
  'api/cancer-screening/observations?encounterId='
export const GET_CANCER_FILE = 'api/cancer-screening/download/'
export const POST_CVAT_ANNOTATE = 'api/cancer-screening/v1/cvat/process'

export const DELETE_DMS_DOCUMENT = '/dms/v1/documents?id='
export const DOWNLOAD_DMS_DOCUMENT = '/dms/v1/documents/download?id='
export const GET_DMS_DOCUMENT = '/dms/v1/documents/download?id='

export const HOMEKARE_GET = 'api/ipd/homekare/wildcard-patient-info?'
export const HOMEKARE_PATCH = 'api/ipd/homekare/status/'

export const SAVE_COMPOSITION = 'api/ipd/initial-assessment/composition'
export const GENERAL_INITIAL_OBSERVATION =
  'api/ipd/initial-assessment/general-initial-observation'
export const BREATHING_OBSERVATION =
  'api/ipd/initial-assessment/breathing-initial-observation'
export const GCS_OBSERVATION = 'api/ipd/initial-assessment/gcs'
export const GENERAL_EXAMINATION_OBSERVATION =
  'api/ipd/initial-assessment/general-examination-observation'
export const GET_COMPOSITION = 'api/ipd/initial-assessment/composition'

// asha worker
export const GET_REGISTRATION_DETAILS = 'api/cancer-screening/getPatients'
export const GET_VISITS_DETAILS = 'api/cancer-screening/getAppointments'
export const QUICK_REGISTRATION = 'api/cancer-screening/registration'
export const CANCER_ASSESSMENT_FORM = 'api/cancer-screening/assessment'
export const CONSENT_FORM_UPLOAD = 'api/cancer-screening/consent'
export const GET_CANCER_ASSESSMENT =
  'api/cancer-screening/assessment/latest?muhId='
export const GET_UPLOAD_CONSENT = 'api/cancer-screening/consent/latest?muhId='

export const GET_CANCER_SCREENING_VISITS =
  'api/cancer-screening/getAppointments'
// asha worker

export const GET_DOCUMENT_ID_HASURA_ENDPOINT =
  'api/api/rest/getDocumentIdsForVisitIds'
export const GET_DOCUMENT_BY_ID_DMS_ENDPOINT =
  'api/dms/v1/documents/download?id='

// tricog
export const UPLOAD_ECG_REPORT = 'api/webhooks/v1/thop/ecg'
export const GET_IPD_ECG_REPORTS = 'api/webhooks/v1/thop/ecg/report/ipd/'
export const GET_OPD_ECG_REPORT = 'api/webhooks/v1/thop/ecg/report/opd/'
export const GET_ECG_REPORT_FILE = 'api/webhooks/v1/download?documentName='
// tricog

// camp management
export const CREAT_CAMP_TYPE = 'api/camp-management/v1/camp-types'
export const GET_CAMP_TYPE = 'api/camp-management/v1/camp-types'
export const CREATE_CAMP = 'api/camp-management/v1/camps'
export const CREATE_CAMP_PATIENT = 'api/camp-management/v1/camps/patients'
export const UPDATE_CAMP_PATIENT =
  'api/camp-management/v1/camps/patients/update'
export const PATIENT_LIST_CAMP =
  'api/camp-management/v1/camps/patients/paginated'
export const GET_DOC_COMMETS = 'api/camp-management/v1/camps/patients/comments'
export const CAMP_VISIT_LINK = 'api/camp-management/v1/camps/visits'
export const CAMP_REPORT = 'api/camp-management/v1/camps/reports/'
export const GET_COMPANY_BY_ID = 'api/api/rest/company'
export const EDIT_DMS_UPLOAD =
  '/dms/v1/documents?documentTypeId=1245978439850901504'
export const GET_SPECIALIZATION =
  'api/camp-management/v1/camps/patients/appointments/specialities'
export const GET_DOCTORS =
  'api/camp-management/v1/camps/patients/appointments/doctors'
export const GET_FOLLOW_UP_ACTIONS =
  'api/camp-management/v1/camps/follow-up-action'
export const GET_CAMP_APPOINTMENTS =
  'api/camp-management/v1/camps/patients/appointments'
export const BASIC_HEALTH_INFO =
  'api/camp-management/v1/camps/patients/appointments/visit/commonInfo'
export const GET_LAB_PACKAGES = 'api/api/rest/packages'
export const GET_PATIENTS_LIST = 'api/fhir/Patient?phone'
export const UPDATE_CAMP_STATUS =
  'api/camp-management/v1/camps/visits/updateStatus'
export const CREATE_CHIEF_COMPLAINTS = 'api/camp-management/v1/chief-complaints'
export const CREATE_MEDICAL_HISTORY = 'api/camp-management/v1/medical-histories'
export const UPLOAD_DOCUMENT = 'api/camp-management/v1/file-transfer/upload'
export const CREATE_CAMP_PATIENT_VITALS = 'api/camp-management/v1/vitals'
export const GET_CAMP_PATIENT_VITALS =
  'api/camp-management/v1/vitals/camp/visit/'
export const UPLOAD_ALL_DOCUMENTS = 'api/camp-management/v1/health-report'

export const CREATE_CAMP_LAB_ORDER =
  'api/camp-management/v1/camps/camp-lab-orders/create-lab-order'

export const GET_CAMP_CLINICAL_LIST =
  'api/camp-management/v1/dashboard/clinical/list'

export const GET_CAMP_LAB_ORDERS = (campsId: any, patientUhid: any) =>
  `api/camp-management/v1/camps/camp-lab-orders/${campsId}/get-patient-lab-orders?patientUhid=${patientUhid}`

export const UPDATE_CAMP_LAB_ORDER = (phoneNumber: any, patientName: any) =>
  `api/camp-management/v1/camps/camp-lab-orders/collect-sample?phoneNumber=${phoneNumber}&patientName=${patientName}`

export const UPLOAD_ECG_SCREENING = 'api/camp-management/v1/camps/ecg'
export const GET_ECG_SCREENING = (
  campsId: any,
  patientUhid: any,
  visitId: any
) =>
  `api/camp-management/v1/camps/ecg?campId=${campsId}&patientUhid=${patientUhid}&visitId=${visitId}`

export const UPLOAD_PFT_SCREENING = 'api/camp-management/v1/camps/Pft'
export const SEND_CAMP_WHATSAPP_MESSAGE =
  'api/camp-management/v1/camps/send-document/whatsapp'
export const GET_PFT_SCREENING = (
  campsId: any,
  patientUhid: any,
  visitId: any
) =>
  `api/camp-management/v1/camps/Pft?campId=${campsId}&patientUhid=${patientUhid}&visitId=${visitId}`

export const UPLOAD_PDF_TO_BUCKET =
  'api/camp-management/v1/file-transfer/upload'

export const DELETE_DOCUMENT = 'api/camp-management/v1/file-transfer/delete'
export const CREATE_OPHTHAMOLOGY_SCREENING = (
  visitId: any,
  patientId: any,
  practitionerId: any
) =>
  `api/camp-management/v1/camps/observations/ophthalmology/upsert?encounterId=${visitId}&patientId=${patientId}&practitionerId=${practitionerId}`

export const GET_OPHTHAMOLOGY_SCREENING = (visitId: any) =>
  `api/camp-management/v1/camps/observations/ophthalmology?encounterId=${visitId}`

export const CREATE_ENT_SCREENING = (
  visitId: any,
  patientId: any,
  practitionerId: any
) =>
  `api/camp-management/v1/camps/observations/ent/upsert?encounterId=${visitId}&patientId=${patientId}&practitionerId=${practitionerId}`

export const GET_ENT_SCREENING = (visitId: any) =>
  `api/camp-management/v1/camps/observations/ent?encounterId=${visitId}`

export const UPDATE_PATIENT_GRADE =
  'api/camp-management/v1/camps/patients/grade/note'

export const GET_PATIENT_GRADE = (muhId: any, campId: any) =>
  `api/camp-management/v1/camps/patients/details?campId=${campId}&patientUhid=${muhId}`

export const UPDATE_LAB_ORDER_BARCODE =
  'api/camp-management/v1/camps/camp-lab-orders/barcode'

// export const DELETE_DOCUMENT = 'camp-management/v1/file-transfer/delete'
export const BULK_UPLOAD = 'api/camp-management/v1/camps/patients/upload'
export const UPDATE_CAMP_VISIT_DOCTOR =
  'api/camp-management/v1/camps/patients/appointments/visit/update'

export const DOWNLOAD_LAB__ORDERS_EXCEL = (
  campId: string,
  fromDate: string,
  toDate: string
) =>
  `api/camp-management/v1/camps/camp-lab-orders/download-excel-streaming?campId=${campId}&from=${fromDate}&to=${toDate}`
export const CAMP_DASHBOARD_STATS = 'api/camp-management/v1/dashboard/'
export const RESEND_NOTIFICATION =
  'api/camp-management/v1/camps/resend-notification'

// SmartQueue
export const SEND_OTP = 'api/ipd/kiosk/send-otp?mobileNumber='
export const POST_QUEUE = 'api/ipd/kiosk/verify-otp?otp='
export const SEARCH_QUEUE = 'api/ipd/kiosk/search?'
export const UPLOAD_MEDPASS = 'api/ipd/patient-documents/upload/'
export const GET_MEDPASS_DOC = 'api/ipd/patient-documents/getDocuments/'
export const DELETE_MEDPASS_DOC = 'api/ipd/patient-documents/delete'
export const MEMBERSHIP_TYPES = '/membership/types'
export const MEMBERSHIP_DASHBOARD = '/membership'
export const MEMBERSHIP_DETAILS = '/membershipDetails'
export const DELETE_DOCUMENT_BY_ID =
  'api/ipd/radiologyFile/deleteDocument?documentId='
